export default __webpack_public_path__ + "static/media/Snd_LowerDMagicC.c93f324b.mp3";